var LOCALE_DATE_OPTIONS = { day: '2-digit', month: '2-digit', year: 'numeric' };
export function formatDate(date, locale) {
    return new Date(date + "T00:00:00").toLocaleDateString(locale, LOCALE_DATE_OPTIONS);
}
import { endOfMonth, isSameDay, format, endOfWeek, formatISO, formatRelative } from 'date-fns';
import { es } from 'date-fns/locale';
export function isEndOfMonth(date) {
    return isSameDay(date, endOfMonth(date));
}
export function isEndOfWeek(date) {
    return isSameDay(date, endOfWeek(date));
}
export function isStartOfMonth(date) {
    return date.getDate() === 1;
}
export function localizedFullMonthName(date) {
    return format(date, 'MMMM', { locale: es });
}
export function localizedFullMonthNameAndYear(date) {
    return format(date, 'MMMM yyyy', { locale: es });
}
export function localizedDayOfWeekShort(date) {
    return format(date, 'E', { locale: es });
}
export function localizedFullDateName(date) {
    return format(date, "dd 'de' MMMM 'de' yyyy", { locale: es });
}
export function localizedTimestamp(date) {
    return format(date, 'dd/MM/yyyy HH:mm', { locale: es });
}
export function asISODateString(date) {
    return formatISO(date, { representation: 'date' });
}
export function localizedFormatRelativeToNow(date) {
    return formatRelative(date, new Date(), { locale: es });
}
